import ClientRoot from "../src/root/ClientRoot";

export default ClientRoot;
